import { DelinquencyStatus } from "models";
import { t } from "utils/i18n";

/**
 * Nhãn hiển thị dùng getter để `t()` chạy lúc truy cập, không phải lúc import module
 * (xem hướng dẫn trong `utils/i18n`) — nếu không, bản dịch riêng theo seller sẽ không áp dụng.
 */
const getDelinquencyStatusLabels = (): Record<DelinquencyStatus, string> => ({
  [DelinquencyStatus.Current]: t("DebtManagement.NormalDebtCustomer"),
  [DelinquencyStatus.Delinquent]: t("DebtManagement.DelinquentDebtCustomer"),
  [DelinquencyStatus.NonPerforming]: t("DebtManagement.NonPerformingDebtCustomer"),
});

const DELINQUENCY_STATUS_COLORS: Record<DelinquencyStatus, string> = {
  [DelinquencyStatus.Current]: "green",
  [DelinquencyStatus.Delinquent]: "orange",
  [DelinquencyStatus.NonPerforming]: "red",
};

/** Options của filter "Trạng thái công nợ" — default chọn hết */
const getDelinquencyStatusOptions = () => {
  const labels = getDelinquencyStatusLabels();
  return Object.values(DelinquencyStatus).map((status) => ({ value: status, label: labels[status] }));
};

const DEFAULT_DELINQUENCY_STATUSES = Object.values(DelinquencyStatus);

export default {
  DELINQUENCY_STATUS_COLORS,
  DEFAULT_DELINQUENCY_STATUSES,
  get DELINQUENCY_STATUS_LABELS() {
    return getDelinquencyStatusLabels();
  },
  get DELINQUENCY_STATUS_OPTIONS() {
    return getDelinquencyStatusOptions();
  },
};
